var map = {
	"./custom.png": "855b",
	"./kemo_12V_10A.png": "da2d",
	"./kemo_24V_10A.png": "12e6",
	"./victron_65A.png": "ffd2",
	"./votronic_12_100.png": "c21e",
	"./votronic_12_40.png": "13b8",
	"./votronic_24_100.png": "bb40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea5e";